import React from 'react';
import { styled } from '@mui/material/styles';
import { tokens } from 'app/components/MatxTheme/themeColors';
import { FONT_MONO } from '../workspaceConstants';

// Handoff button spec: Plex Mono 11px uppercase, 600, letter-spacing 0.6,
// 6px radius. Variants: accent / outlined / outlinedNeutral / contained / ghost.
// `outlined` is the pink-accent (error red) bordered button; `outlinedNeutral`
// is the same shape with a grey border for secondary actions.
const VARIANTS = {
    accent: {
        background: tokens.vestYellow[500],
        color: tokens.grey[1000],
        border: `1px solid ${tokens.vestYellow[500]}`,
        '&:hover': { background: tokens.vestYellow[600] },
    },
    outlined: {
        background: 'transparent',
        color: tokens.pinkAccent[500],
        border: `1px solid ${tokens.pinkAccent[500]}`,
        '&:hover': { background: tokens.pinkAccent[50] },
    },
    outlinedNeutral: {
        background: 'transparent',
        color: tokens.grey[1000],
        border: `1px solid ${tokens.grey[300]}`,
        '&:hover': { background: tokens.grey[100] },
    },
    contained: {
        background: tokens.grey[1000],
        color: tokens.vestYellow[500],
        border: `1px solid ${tokens.grey[1000]}`,
        '&:hover': { background: tokens.grey[950] },
    },
    ghost: {
        background: 'transparent',
        color: tokens.grey[900],
        border: '1px solid transparent',
        '&:hover': { background: tokens.grey[100] },
    },
};

const Root = styled('button', {
    shouldForwardProp: (prop) => prop !== 'variantKey',
})(({ variantKey }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontFamily: FONT_MONO,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    borderRadius: 6,
    padding: '6px 12px',
    cursor: 'pointer',
    transition: 'background 120ms ease',
    whiteSpace: 'nowrap',
    '&:disabled': {
        opacity: 0.5,
        cursor: 'not-allowed',
    },
    ...VARIANTS[variantKey],
}));

const WorkspaceButton = ({
    variant = 'outlined',
    icon = null,
    children,
    ...rest
}) => (
    <Root type="button" variantKey={variant} {...rest}>
        {icon}
        {children}
    </Root>
);

export default WorkspaceButton;
